import React from "react"
import { compose, withProps } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"

// Chave vem do ambiente (REACT_APP_GOOGLE_MAPS_KEY); restrinja-a por dominio no Google Cloud
const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY

// Sem chave o Google responde InvalidKeyMapError: as telas escondem o mapa em vez de mostrar o erro.
export const isMapsEnabled = () => Boolean(GOOGLE_MAPS_KEY)

const MyMapComponent = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_KEY}`,
    loadingElement: < div style={{ height: `100%` }} />,
    containerElement: < div style={{ height: `100%` }} />,
    mapElement: < div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)((props) =>
  <GoogleMap
    defaultZoom={12}
    defaultCenter={{ lat: parseFloat(props.lat), lng: parseFloat(props.lng) }}
    center={{ lat: parseFloat(props.lat), lng: parseFloat(props.lng) }}
  >

    {props.isMarkerShown && props.markers.map((marker, index) => (
      <Marker key={index} position={{ lat: parseFloat(marker.latitude), lng: parseFloat(marker.longitude) }} title={marker.tradingName} />
    ))}

  </GoogleMap>
)

class MyFancyComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isMarkerShown: true,
      Cidade: this.props.city,
      States: this.props.states,
      latitude: 0.0,
      longitude: 0.0
    }
  }

  componentDidMount() {
    this.getLatLong()
  }

  getLatLong = async () => {
    var _this = this
    fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${this.state.Cidade}+${this.state.States}&key=${GOOGLE_MAPS_KEY}`)
      .then(function (response) {
        return response.json();
      }).then(function (data) {
        const location = data?.results?.[0]?.geometry?.location
        if (location) {
          _this.setState({ latitude: location.lat, longitude: location.lng })
          return
        }
        // Sem geocodificacao (chave ausente ou cidade nao achada): centraliza no primeiro marcador.
        _this.centerOnFirstMarker()
      })
      .catch(() => _this.centerOnFirstMarker())
  }

  centerOnFirstMarker = () => {
    const first = (this.props.list || []).find(item => item.latitude && item.longitude)
    if (first) this.setState({ latitude: first.latitude, longitude: first.longitude })
  }

  render() {
    return (
      <MyMapComponent
        isMarkerShown={this.state.isMarkerShown}
        onMarkerClick={this.handleMarkerClick}
        markers={this.props.list}
        defaultCenter={this.props.list[0]}
        lat={this.state.latitude}
        lng={this.state.longitude}
      />
    )
  }
}

export default MyFancyComponent